var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMeasure = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 400 272"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#measure_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#131927",
  fillOpacity: 0.07,
  d: "M199.512 272c109.636 0 198.513-29.808 198.513-66.577s-88.877-66.577-198.513-66.577C89.877 138.846 1 168.654 1 205.423S89.877 272 199.512 272"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E6A445",
  d: "M254.422 130.415H106.033v57.588h148.389z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ECBC49",
  d: "m86.837 131.755-.07 56.333c-.03.25-.049.503-.049.756s.019.49.046.731c1.255 11.173 31.122 20.354 70.038 22.14a302 302 0 0 0 26.461.054l125.094.263.119-57.546-137.828-.384-83.808-22.344z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D9AE44",
  d: "M254.593 130.789c0 12.81-37.57 23.191-83.911 23.191S86.77 143.596 86.77 130.789s37.567-23.19 83.912-23.19 83.911 10.384 83.911 23.19"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C39D3E",
  d: "M233.998 130.789c0 9.665-28.346 17.499-63.316 17.499s-63.314-7.834-63.314-17.499 28.346-17.499 63.314-17.499c34.967 0 63.316 7.834 63.316 17.499"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A78937",
  d: "M211.115 130.789c0 6.173-18.102 11.174-40.43 11.174-22.329 0-40.431-5.004-40.431-11.174s18.102-11.173 40.431-11.173 40.43 5.003 40.43 11.173"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ECBC49",
  d: "M197.383 130.789c0 4.077-11.954 7.38-26.701 7.38s-26.698-3.303-26.698-7.38 11.953-7.38 26.698-7.38c14.744 0 26.701 3.303 26.701 7.38"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31290C",
  d: "m295.252 211.769 5.18.009v-12.806h-5.18zM284.588 211.769l5.18.009v-12.806h-5.18zM273.923 211.769l5.18.009v-12.806h-5.18zM262.954 211.769l5.18.01V185.26h-5.18zM251.985 211.769l5.18.009v-12.806h-5.18zM241.32 211.769l5.18.009v-12.806h-5.18zM230.351 211.769l5.18.009v-12.806h-5.18zM219.687 211.769l5.18.01v-26.214h-5.18zM208.717 211.769l5.18.009v-12.806h-5.18zM198.053 211.769l5.18.009v-12.806h-5.18zM192.264 211.778v-12.806h-5.18v12.797zM176.419 211.73q2.611-.05 5.18-.14v-26.333h-5.18zM165.45 211.849c1.715.03 3.437.048 5.18.048v-12.928h-5.18zM154.481 211.477q1.11.059 2.233.11 1.464.062 2.947.115v-12.73h-5.18zM143.816 210.691q2.555.232 5.18.42v-12.142h-5.18zM133.152 209.341q2.541.344 5.18.643v-24.727h-5.18zM121.878 207.754q2.523.485 5.18.92v-13.361h-5.18zM111.213 205.017q2.492.672 5.18 1.289v-13.428h-5.18zM100.549 201.474a80 80 0 0 0 5.18 1.904v-13.245h-5.18zM89.884 194.831c1.332 1.298 3.075 2.548 5.18 3.742v-22.152h-5.18z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A8A8A8",
  d: "M315.972 156.75c0-2.045-1.575-3.806-3.617-3.888a3.77 3.77 0 0 0-3.806 2.837c-.039 0-.079-.012-.118-.012a2.51 2.51 0 0 0-2.514 2.513v50.59a2.513 2.513 0 0 0 2.514 2.514c.039 0 .079-.01.118-.013a3.77 3.77 0 0 0 3.806 2.837c2.042-.082 3.617-1.843 3.617-3.888v-53.493z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "measure_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h400v272H0z"
})))));
export default SvgMeasure;